const config = {
  API_BASE_URL: process.env.NODE_ENV === 'production' 
    ? './backend/api' 
    : 'http://localhost/client/Vibha555/backend/api',
  ADMIN_API_BASE_URL: process.env.NODE_ENV === 'production' 
    ? './backend/admin' 
    : 'http://localhost/client/Vibha555/backend/admin'
};

export default config;
